import { SearchTerm } from './SearchTerm';

const AuditActionTypeSearch: SearchTerm [] = [
    {
        heading: 'Name',
        accessor: 'name',
        searchOnName: 'nameOriginal',
        translationKey: "name"
    }
];

export default AuditActionTypeSearch;

